// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/content-card/content-card.component.scss
// module id = 218
// module chunks = 0